import { axios } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altStaffLists = (data) => ({
  type: TYPES.ALT_STAFF_LISTS,
  data,
})

export const getAllStaff = (page = 1, limit = 10, search = '') => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams({ page, limit, search }).toString()
    const response = await axios.get(`/staff?${queryParams}`)
    
    // Backend returns: { status, data: [...staff], pagination }
    if (response && response.data) {
      const normalizedData = {
        data: response.data.map(staff => ({
          id: staff.id,
          firstName: staff.firstName,
          lastName: staff.lastName,
          fullName: `${staff.firstName} ${staff.lastName}`,
          email: staff.email,
          phone: staff.phone,
          role: staff.role,
          status: staff.assignmentStatus || staff.status,
          assignmentId: staff.assignmentId,
          createdAt: staff.createdAt,
          updatedAt: staff.updatedAt,
        })),
        pagination: response.pagination,
      }
      
      dispatch(altStaffLists(normalizedData))
    }
  } catch (error) {
    console.error('Get staff error:', error)
    toast.error(error.response?.data?.message || 'Failed to fetch staff')
  }
}

export const checkStaffEmail = async (email) => {
  try {
    const response = await axios.get(`/staff/check-email/${encodeURIComponent(email)}`)
    return response.exists
  } catch (error) {
    console.error('Check email error:', error)
    return false
  }
}

export const createStaff = (staffData) => async (dispatch) => {
  try {
    const response = await axios.post('/staff', staffData)
    
    if (response && response.status === 'success') {
      toast.success('Staff member added successfully')
      dispatch(getAllStaff())
      return { success: true }
    }
  } catch (error) {
    console.error('Create staff error:', error)
    const message = error.response?.data?.message || 'Failed to add staff member'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const updateStaff = (id, staffData) => async (dispatch) => {
  try {
    const response = await axios.put(`/staff/${id}`, staffData)
    
    if (response && response.status === 'success') {
      toast.success('Staff member updated successfully')
      dispatch(getAllStaff())
      return { success: true }
    }
  } catch (error) {
    console.error('Update staff error:', error)
    const message = error.response?.data?.message || 'Failed to update staff member'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const toggleStaffStatus = (id) => async (dispatch) => {
  try {
    const response = await axios.patch(`/staff/${id}/status`)
    
    if (response && response.status === 'success') {
      toast.success('Staff status updated successfully')
      dispatch(getAllStaff())
    }
  } catch (error) {
    console.error('Toggle status error:', error)
    toast.error(error.response?.data?.message || 'Failed to update staff status')
  }
}

export const deleteStaff = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(`/staff/${id}`)
    
    if (response && response.status === 'success') {
      toast.success('Staff member deleted successfully')
      dispatch(getAllStaff())
      return { success: true }
    }
  } catch (error) {
    console.error('Delete staff error:', error)
    toast.error(error.response?.data?.message || 'Failed to delete staff member')
    return { success: false }
  }
}

